"use client";

import { NextIntlClientProvider, useLocale, useMessages } from "next-intl";
import type { ReactNode } from "react";

type Props = {
  deMessages: Record<string, unknown>;
  enMessages: Record<string, unknown>;
  children: ReactNode;
};

/**
 * Provides blog-specific translations as a nested NextIntlClientProvider
 * that merges with the parent provider's messages.
 *
 * Blog messages are filtered out of the parent layout provider to reduce
 * bundle size. Each blog page wraps its content with this provider to
 * supply its specific blog messages alongside the existing common messages.
 */
export default function BlogIntlProvider({
  deMessages,
  enMessages,
  children,
}: Props) {
  const locale = useLocale();
  const parentMessages = useMessages();
  const blogMessages = locale === "en" ? enMessages : deMessages;

  const mergedMessages = {
    ...parentMessages,
    ...blogMessages,
  } as Record<string, unknown>;

  return (
    <NextIntlClientProvider locale={locale} messages={mergedMessages}>
      {children}
    </NextIntlClientProvider>
  );
}
